import React from "react";
import { Icon } from "@iconify/react";

const phone = process.env.REACT_APP_HELP_CENTER_PHONE?.trim() ?? "";

const HelpCenterButton = () => {
  if (!phone) return null;

  return (
    <a
      href={`tel:${phone}`}
      aria-label="Call help center"
      title="Help Center"
      style={{
        position: "fixed",
        bottom: "1.2rem",
        right: "1rem",
        zIndex: 1060,
        width: 52,
        height: 52,
        borderRadius: "50%",
        backgroundColor: "#e53935",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
        textDecoration: "none",
        transition: "background-color 0.15s ease, transform 0.15s ease",
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLAnchorElement).style.backgroundColor = "#b71c1c";
        (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1.08)";
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLAnchorElement).style.backgroundColor = "#e53935";
        (e.currentTarget as HTMLAnchorElement).style.transform = "scale(1)";
      }}
    >
      <Icon icon="mdi:headset" style={{ fontSize: "1.6rem", color: "#fff" }} />
    </a>
  );
};

export default HelpCenterButton;
